export default __webpack_public_path__ + "static/media/train.f2086604.svg";